import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import jsPDF from 'jspdf';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Personal } from 'src/app/Models/personal/personal';
import { DataService } from 'src/app/Service/data.service';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-print-ventas-diarias-detallado',
  templateUrl: './print-ventas-diarias-detallado.component.html',
  styleUrls: ['./print-ventas-diarias-detallado.component.css']
})
export class PrintVentasDiariasDetalladoComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer, private data: DataService, private reportViewer: ReportViewerService, private datePipe: DatePipe, private cdr: ChangeDetectorRef) { }
  mes: string = '1';
  idvende: string = '1';
  public detfactus: any[] = [];
  totalcantidad: number = 0;
  totalefectivo: number = 0;
  totalfise: number = 0;
  totalyape: number = 0;
  totaltarjetacredito: number = 0;
  totalcredito: number = 0;
  totalgeneral: number = 0;
  public personal: Personal = new Personal()
  public today = new Date();
  public fecinicio: any;
  public fecfin: any;
  public filtro: Filtro = new Filtro()
  public sucursal: number;
  pdfBlob: Blob | null = null;
  pdfUrl: SafeResourceUrl | null = null;
  pdfObjectUrl: string = '';
  @ViewChild('pagina', null) public pagina: ElementRef;
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('pdfIframe', null) pdfIframe: ElementRef;

  ngOnInit() {
  }

  GetData(filtro: Filtro) {
    this.data.Post('reporte_diario_detallado', filtro).subscribe({
      next: (r: any) => {
        console.log('Respuesta reporte diario:', r);
        if (r.message === "success") {
          this.fecinicio = filtro.fecini;
          this.fecfin = filtro.fecfin;
          this.cdr.detectChanges();

          setTimeout(() => {
            // Generar el PDF
            const blob = this.printerVentasDiariosDetallado(
              r.data,
              r.clases,
              r.articulos,
              r.nombres_articulos
            );

            // Mostrar en el modal reutilizable (SIMPLIFICADO)
            if (blob) {
              const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
              this.reportViewer.mostrarPDF(
                blob,
                'Reporte de Ventas Diarias Detallado',
                `reporte_ventas_diarias_detallado_${fecha}.pdf`
              );
            }
          }, 0);
        } else {
          console.warn("No se pudo obtener datos. Mensaje:", r.message);
        }
      },
      error: (err: any) => {
        console.error("Error al obtener datos del reporte diario:", err);
      }
    });
  }



  printerVentasDiariosDetallado1(
    ventasData: any[],
    clases: any,
    articulos: string[],
    nombresArticulos?: { [codigo: string]: string }
  ): Blob | null {
    const doc = new jsPDF('landscape');
    const titulo = { text: 'REPORTE DIARIO DETALLADO', x: 120, y: 20 };

    const addHeader = () => {
      doc.setFontSize(12);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);
      const lineY = titulo.y + 1;
      doc.setLineWidth(0.5);
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(9);
      doc.text(`Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`, 10, 28);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 220, 28);
      doc.setFontSize(10);
    };

    const nombres = nombresArticulos || {};
    const obtenerNombre = (codigo: string, maxLen = 40): string => {
      const key = String(codigo).trim();
      const raw = nombres[key];
      if (raw && String(raw).trim()) {
        const name = String(raw).trim();
        return name.length > maxLen ? name.slice(0, maxLen - 1).trim() + '…' : name;
      }
      return '';
    };

    const tableRows: any[] = [];
    const totales: any = {
      vendedor: 'TOTAL',
      balones_envasado: {},
      balones_vacios: {},
      plato: 0,
      efectivo: 0,
      fise: 0,
      yape: 0,
      tarjeta: 0,    // RENOMBRADO de deposito a tarjeta
      deposito: 0,   // NUEVO: depósito desde Liquidacion
      gasto: 0,
      credito: 0,
      total: 0,
      saldo_faltante: 0
    };

    let codigosEnvasado: string[] = [];
    let codigosVacio: string[] = [];

    Object.keys(clases || {}).forEach((clase: string) => {
      if (clase.toUpperCase().includes('ENVASADO')) {
        codigosEnvasado = clases[clase] || [];
      } else if (clase.toUpperCase().includes('VACIO')) {
        codigosVacio = clases[clase] || [];
      }
    });

    codigosEnvasado.forEach((codigo: string) => { totales.balones_envasado[codigo] = 0; });
    codigosVacio.forEach((codigo: string) => { totales.balones_vacios[codigo] = 0; });

    ventasData.forEach((venta: any) => {
      const row: any[] = [];
      row.push(venta.vendedor || '');

      codigosEnvasado.forEach((codigo: string) => {
        const valor = Number(venta[String(codigo)] || 0);
        row.push(valor);
        totales.balones_envasado[codigo] += valor;
      });

      codigosVacio.forEach((codigo: string) => {
        const valor = Number(venta[String(codigo)] || 0);
        row.push(valor);
        totales.balones_vacios[codigo] += valor;
      });

      row.push(venta.plato || 0);
      row.push(venta.efectivo ? Number(venta.efectivo).toFixed(1) : '0.0');
      row.push(venta.fise || 0);
      row.push(venta.yape ? Number(venta.yape).toFixed(1) : '0.0');
      row.push(venta.tarjeta ? Number(venta.tarjeta).toFixed(1) : '0.0');    // RENOMBRADO
      row.push(venta.deposito ? Number(venta.deposito).toFixed(1) : '0.0');  // NUEVO
      row.push(venta.gasto ? Number(venta.gasto).toFixed(1) : '0.0');
      row.push(venta.credito || 0);
      row.push(venta.total ? Number(venta.total).toFixed(1) : '0.0');
      row.push(venta.saldo_faltante ? Number(venta.saldo_faltante).toFixed(1) : '0.0');

      totales.plato += (venta.plato || 0);
      totales.efectivo += (venta.efectivo || 0);
      totales.fise += (venta.fise || 0);
      totales.yape += (venta.yape || 0);
      totales.tarjeta += (venta.tarjeta || 0);      // RENOMBRADO
      totales.deposito += (venta.deposito || 0);    // NUEVO
      totales.gasto += (venta.gasto || 0);
      totales.credito += (venta.credito || 0);
      totales.total += (venta.total || 0);
      totales.saldo_faltante += (venta.saldo_faltante || 0);

      tableRows.push(row);
    });

    const rowTotal: any[] = [];
    rowTotal.push('TOTAL');
    codigosEnvasado.forEach((codigo: string) => rowTotal.push(totales.balones_envasado[codigo]));
    codigosVacio.forEach((codigo: string) => rowTotal.push(totales.balones_vacios[codigo]));
    rowTotal.push(totales.plato);
    rowTotal.push(totales.efectivo.toFixed(1));
    rowTotal.push(totales.fise);
    rowTotal.push(totales.yape.toFixed(1));
    rowTotal.push(totales.tarjeta.toFixed(1));    // RENOMBRADO
    rowTotal.push(totales.deposito.toFixed(1));   // NUEVO
    rowTotal.push(totales.gasto.toFixed(1));
    rowTotal.push(totales.credito);
    rowTotal.push(totales.total.toFixed(1));
    rowTotal.push(totales.saldo_faltante.toFixed(1));
    tableRows.push(rowTotal);

    const headerRow1: any[] = [];
    const headerRow2: any[] = [];

    headerRow1.push({
      content: 'VENDEDOR',
      rowSpan: 2,
      styles: { halign: 'center', valign: 'middle', fillColor: [200, 200, 200] }
    });

    headerRow1.push({
      content: 'BALON ENVASADO',
      colSpan: Math.max(codigosEnvasado.length, 1),
      styles: { halign: 'center', fillColor: [255, 255, 0], textColor: [0, 0, 0] }
    });

    headerRow1.push({
      content: 'BALON VACIO',
      colSpan: Math.max(codigosVacio.length, 1),
      styles: { halign: 'center', fillColor: [255, 255, 0], textColor: [0, 0, 0] }
    });

    // MODIFICADO: Agregada columna DEPOSITO
    const otrasColumnas = ['plato', 'efectivo', 'fise', 'yape', 'tarjeta', 'deposito', 'gasto', 'credito', 'total', 'saldo faltante'];
    otrasColumnas.forEach(col => {
      headerRow1.push({
        content: col.toUpperCase(),
        rowSpan: 2,
        styles: { halign: 'center', valign: 'middle', fillColor: [200, 200, 200] }
      });
    });

    codigosEnvasado.forEach((codigo: string) => {
      const label = obtenerNombre(codigo, 80);
      headerRow2.push({
        content: label,
        styles: { halign: 'center', fillColor: [220, 220, 220], cellWidth: 18, overflow: 'linebreak' }
      });
    });

    codigosVacio.forEach((codigo: string) => {
      const label = obtenerNombre(codigo, 80);
      headerRow2.push({
        content: label,
        styles: { halign: 'center', fillColor: [220, 220, 220], cellWidth: 18, overflow: 'linebreak' }
      });
    });

    const columnStyles: any = {
      0: { halign: 'left', cellWidth: 32 }
    };
    let colIndex = 1;
    for (let i = 0; i < codigosEnvasado.length; i++) {
      columnStyles[colIndex++] = { halign: 'center', cellWidth: 18 };
    }
    for (let i = 0; i < codigosVacio.length; i++) {
      columnStyles[colIndex++] = { halign: 'center', cellWidth: 18 };
    }
    for (let i = 0; i < otrasColumnas.length; i++) {
      columnStyles[colIndex++] = { halign: 'right', cellWidth: 13 };
    }

    (doc as any).autoTable({
      head: [headerRow1, headerRow2],
      body: tableRows,
      startY: 32,
      margin: { horizontal: 5 },
      theme: 'grid',
      columnStyles,
      styles: {
        fontSize: 6,
        cellPadding: 0.9,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        fontSize: 6
      },
      didParseCell: (data: any) => {
        if (data.row.index === tableRows.length - 1 && data.section === 'body') {
          data.cell.styles.fontStyle = 'bold';
        }
      },
      didDrawPage: (data: any) => {
        addHeader();
        const pageNumber = data.pageNumber;
        doc.text(`Página ${pageNumber}`, 260, 15);
      }
    });

    return doc.output('blob');
  }


  printerVentasDiariosDetallado2(
    ventasData: any[],
    clases: any,
    articulos: string[],
    nombresArticulos?: { [codigo: string]: string }
  ): Blob | null {
    const doc = new jsPDF('landscape');
    let pageNumber = 1;

    // Función para agregar encabezado
    const addHeader = (subtitulo?: string) => {
      doc.setFontSize(14);
      const mainTitle = 'REPORTE DIARIO DETALLADO';
      doc.text(mainTitle, doc.internal.pageSize.getWidth() / 2, 15, { align: 'center' });

      if (subtitulo) {
        doc.setFontSize(11);
        doc.text(subtitulo, doc.internal.pageSize.getWidth() / 2, 22, { align: 'center' });
      }

      doc.setFontSize(9);
      doc.text(
        `Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`,
        10, subtitulo ? 28 : 22
      );
      doc.text(
        `Generado el día ${this.formatFecha(this.today, 'dd-MM-yyyy HH:mm')}`,
        doc.internal.pageSize.getWidth() - 10, subtitulo ? 28 : 22,
        { align: 'right' }
      );
      doc.text(
        `Página ${pageNumber}`,
        doc.internal.pageSize.getWidth() - 10,
        10,
        { align: 'right' }
      );
      pageNumber++;
    };

    // Helper para obtener nombres
    const nombres = nombresArticulos || {};
    const obtenerNombre = (codigo: string, maxLen = 30): string => {
      const key = String(codigo).trim();
      const raw = nombres[key];
      if (raw && String(raw).trim()) {
        const name = String(raw).trim();
        return name.length > maxLen ? name.slice(0, maxLen - 1).trim() + '…' : name;
      }
      return codigo; // Si no hay nombre, mostrar el código
    };

    // Identificar códigos por clase
    let codigosEnvasado: string[] = [];
    let codigosVacio: string[] = [];

    Object.keys(clases || {}).forEach((clase: string) => {
      const claseUpper = clase.toUpperCase();
      if (claseUpper.includes('ENVASADO')) {
        codigosEnvasado = clases[clase] || [];
      } else if (claseUpper.includes('VACIO') || claseUpper.includes('VACÍO')) {
        codigosVacio = clases[clase] || [];
      }
    });

    // ==============================================
    // PÁGINA 1: RESUMEN GENERAL (Datos Monetarios)
    // ==============================================
    addHeader('Resumen General - Datos Monetarios');

    const columnasGenerales = [
      'VENDEDOR', 'PLATOS', 'EFECTIVO', 'YAPE', 'FISE',
      'TARJETA', 'DEPÓSITO', 'GASTO', 'CRÉDITO', 'TOTAL', 'SALDO FALT.'
    ];

    const rowsGenerales: any[] = [];
    const totalesGenerales = {
      plato: 0, efectivo: 0, yape: 0, fise: 0, tarjeta: 0,
      deposito: 0, gasto: 0, credito: 0, total: 0, saldo_faltante: 0
    };

    ventasData.forEach((venta: any) => {
      const row = [
        venta.vendedor || '',
        venta.plato || 0,
        Number(venta.efectivo || 0).toFixed(1),
        Number(venta.yape || 0).toFixed(1),
        Number(venta.fise || 0).toFixed(1),
        Number(venta.tarjeta || 0).toFixed(1),
        Number(venta.deposito || 0).toFixed(1),
        Number(venta.gasto || 0).toFixed(1),
        Number(venta.credito || 0).toFixed(1),
        Number(venta.total || 0).toFixed(1),
        Number(venta.saldo_faltante || 0).toFixed(1)
      ];
      rowsGenerales.push(row);

      totalesGenerales.plato += venta.plato || 0;
      totalesGenerales.efectivo += Number(venta.efectivo || 0);
      totalesGenerales.yape += Number(venta.yape || 0);
      totalesGenerales.fise += Number(venta.fise || 0);
      totalesGenerales.tarjeta += Number(venta.tarjeta || 0);
      totalesGenerales.deposito += Number(venta.deposito || 0);
      totalesGenerales.gasto += Number(venta.gasto || 0);
      totalesGenerales.credito += Number(venta.credito || 0);
      totalesGenerales.total += Number(venta.total || 0);
      totalesGenerales.saldo_faltante += Number(venta.saldo_faltante || 0);
    });

    rowsGenerales.push([
      'TOTAL',
      totalesGenerales.plato,
      totalesGenerales.efectivo.toFixed(1),
      totalesGenerales.yape.toFixed(1),
      totalesGenerales.fise.toFixed(1),
      totalesGenerales.tarjeta.toFixed(1),
      totalesGenerales.deposito.toFixed(1),
      totalesGenerales.gasto.toFixed(1),
      totalesGenerales.credito.toFixed(1),
      totalesGenerales.total.toFixed(1),
      totalesGenerales.saldo_faltante.toFixed(1)
    ]);

    (doc as any).autoTable({
      head: [columnasGenerales],
      body: rowsGenerales,
      startY: 32,
      margin: { horizontal: 10 },
      theme: 'grid',
      headStyles: {
        halign: 'center',
        fillColor: [52, 152, 219],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: 8
      },
      columnStyles: {
        0: { halign: 'left', cellWidth: 45 },
        1: { halign: 'center', cellWidth: 18 },
        2: { halign: 'right', cellWidth: 22 },
        3: { halign: 'right', cellWidth: 22 },
        4: { halign: 'right', cellWidth: 20 },
        5: { halign: 'right', cellWidth: 22 },
        6: { halign: 'right', cellWidth: 22 },
        7: { halign: 'right', cellWidth: 20 },
        8: { halign: 'right', cellWidth: 20 },
        9: { halign: 'right', cellWidth: 22 },
        10: { halign: 'right', cellWidth: 25 }
      },
      styles: {
        fontSize: 7,
        cellPadding: 2
      },
      didParseCell: (data: any) => {
        if (data.row.index === rowsGenerales.length - 1 && data.section === 'body') {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fillColor = [236, 240, 241];
        }
      }
    });

    // ==============================================
    // PÁGINA 2: BALONES ENVASADOS
    // ==============================================
    if (codigosEnvasado.length > 0) {
      doc.addPage('landscape');
      addHeader('Detalle de Balones Envasados');

      const columnasEnvasado = ['VENDEDOR', ...codigosEnvasado.map(c => obtenerNombre(c, 25)), 'TOTAL'];
      const rowsEnvasado: any[] = [];
      const totalesEnvasado: any = {};
      codigosEnvasado.forEach(c => totalesEnvasado[c] = 0);
      let granTotalEnvasado = 0;

      ventasData.forEach((venta: any) => {
        const row = [venta.vendedor || ''];
        let totalVendedor = 0;

        codigosEnvasado.forEach((codigo: string) => {
          const valor = Number(venta[codigo] || 0);
          row.push(valor);
          totalesEnvasado[codigo] += valor;
          totalVendedor += valor;
        });

        row.push(totalVendedor);
        granTotalEnvasado += totalVendedor;
        rowsEnvasado.push(row);
      });

      const rowTotalEnvasado = ['TOTAL'];
      codigosEnvasado.forEach(c => rowTotalEnvasado.push(totalesEnvasado[c]));
      rowTotalEnvasado.push(granTotalEnvasado.toString());
      rowsEnvasado.push(rowTotalEnvasado);

      // Calcular anchos dinámicos
      const numColumnas = codigosEnvasado.length + 2; // +2 por vendedor y total
      const anchoDisponible = doc.internal.pageSize.getWidth() - 20; // margins
      const anchoVendedor = 50;
      const anchoTotal = 25;
      const anchoRestante = anchoDisponible - anchoVendedor - anchoTotal;
      const anchoArticulo = Math.max(15, anchoRestante / codigosEnvasado.length);

      const columnStylesEnvasado: any = {
        0: { halign: 'left', cellWidth: anchoVendedor }
      };
      for (let i = 1; i <= codigosEnvasado.length; i++) {
        columnStylesEnvasado[i] = { halign: 'center', cellWidth: anchoArticulo };
      }
      columnStylesEnvasado[codigosEnvasado.length + 1] = {
        halign: 'center',
        cellWidth: anchoTotal,
        fontStyle: 'bold'
      };

      (doc as any).autoTable({
        head: [columnasEnvasado],
        body: rowsEnvasado,
        startY: 32,
        margin: { horizontal: 10 },
        theme: 'grid',
        headStyles: {
          halign: 'center',
          fillColor: [255, 193, 7],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          fontSize: 7
        },
        columnStyles: columnStylesEnvasado,
        styles: {
          fontSize: 7,
          cellPadding: 2,
          overflow: 'linebreak'
        },
        didParseCell: (data: any) => {
          if (data.row.index === rowsEnvasado.length - 1 && data.section === 'body') {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fillColor = [255, 243, 205];
          }
        }
      });
    }

    // ==============================================
    // PÁGINA 3: BALONES VACÍOS
    // ==============================================
    if (codigosVacio.length > 0) {
      doc.addPage('landscape');
      addHeader('Detalle de Balones Vacíos');

      const columnasVacio = ['VENDEDOR', ...codigosVacio.map(c => obtenerNombre(c, 25)), 'TOTAL'];
      const rowsVacio: any[] = [];
      const totalesVacio: any = {};
      codigosVacio.forEach(c => totalesVacio[c] = 0);
      let granTotalVacio = 0;

      ventasData.forEach((venta: any) => {
        const row = [venta.vendedor || ''];
        let totalVendedor = 0;

        codigosVacio.forEach((codigo: string) => {
          const valor = Number(venta[codigo] || 0);
          row.push(valor);
          totalesVacio[codigo] += valor;
          totalVendedor += valor;
        });

        row.push(totalVendedor);
        granTotalVacio += totalVendedor;
        rowsVacio.push(row);
      });

      const rowTotalVacio = ['TOTAL'];
      codigosVacio.forEach(c => rowTotalVacio.push(totalesVacio[c]));
      rowTotalVacio.push(granTotalVacio.toString());
      rowsVacio.push(rowTotalVacio);

      // Calcular anchos dinámicos
      const anchoDisponible = doc.internal.pageSize.getWidth() - 20;
      const anchoVendedor = 50;
      const anchoTotal = 25;
      const anchoRestante = anchoDisponible - anchoVendedor - anchoTotal;
      const anchoArticulo = Math.max(15, anchoRestante / codigosVacio.length);

      const columnStylesVacio: any = {
        0: { halign: 'left', cellWidth: anchoVendedor }
      };
      for (let i = 1; i <= codigosVacio.length; i++) {
        columnStylesVacio[i] = { halign: 'center', cellWidth: anchoArticulo };
      }
      columnStylesVacio[codigosVacio.length + 1] = {
        halign: 'center',
        cellWidth: anchoTotal,
        fontStyle: 'bold'
      };

      (doc as any).autoTable({
        head: [columnasVacio],
        body: rowsVacio,
        startY: 32,
        margin: { horizontal: 10 },
        theme: 'grid',
        headStyles: {
          halign: 'center',
          fillColor: [156, 39, 176],
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          fontSize: 7
        },
        columnStyles: columnStylesVacio,
        styles: {
          fontSize: 7,
          cellPadding: 2,
          overflow: 'linebreak'
        },
        didParseCell: (data: any) => {
          if (data.row.index === rowsVacio.length - 1 && data.section === 'body') {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fillColor = [225, 190, 231];
          }
        }
      });
    }

    return doc.output('blob');
  }

  printerVentasDiariosDetallado(
    ventasData: any[],
    clases: any,
    articulos: string[],
    nombresArticulos?: { [codigo: string]: string }
  ): Blob | null {
    const doc = new jsPDF('landscape');
    let pageNumber = 1;

    // Función para agregar encabezado
    const addHeader = (subtitulo?: string) => {
      doc.setFontSize(14);
      const mainTitle = 'REPORTE DIARIO DETALLADO';
      doc.text(mainTitle, doc.internal.pageSize.getWidth() / 2, 15, { align: 'center' });

      if (subtitulo) {
        doc.setFontSize(11);
        doc.text(subtitulo, doc.internal.pageSize.getWidth() / 2, 22, { align: 'center' });
      }

      doc.setFontSize(9);
      doc.text(
        `Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`,
        10, subtitulo ? 28 : 22
      );
      doc.text(
        `Generado el día ${this.formatFecha(this.today, 'dd-MM-yyyy HH:mm')}`,
        doc.internal.pageSize.getWidth() - 10, subtitulo ? 28 : 22,
        { align: 'right' }
      );
      doc.text(
        `Página ${pageNumber}`,
        doc.internal.pageSize.getWidth() - 10,
        10,
        { align: 'right' }
      );
      pageNumber++;
    };

    // Helper para obtener nombres
    const nombres = nombresArticulos || {};
    const obtenerNombre = (codigo: string, maxLen = 20): string => {
      const key = String(codigo).trim();
      const raw = nombres[key];
      if (raw && String(raw).trim()) {
        const name = String(raw).trim();
        return name.length > maxLen ? name.slice(0, maxLen - 1).trim() + '…' : name;
      }
      return codigo;
    };

    // Identificar códigos por clase
    let codigosEnvasado: string[] = [];
    let codigosVacio: string[] = [];

    Object.keys(clases || {}).forEach((clase: string) => {
      const claseUpper = clase.toUpperCase();
      if (claseUpper.includes('ENVASADO')) {
        codigosEnvasado = clases[clase] || [];
      } else if (claseUpper.includes('VACIO') || claseUpper.includes('VACÍO')) {
        codigosVacio = clases[clase] || [];
      }
    });

    // ==============================================
    // PÁGINA 1: BALONES ENVASADOS + PLATOS + DATOS MONETARIOS
    // ==============================================
    addHeader('Detalle de Balones Envasados');

    // Construir encabezados con dos filas
    const headerRow1Envasado: any[] = [];
    const headerRow2Envasado: any[] = [];

    // Columna VENDEDOR
    headerRow1Envasado.push({
      content: 'VENDEDOR',
      rowSpan: 2,
      styles: { halign: 'center', valign: 'middle', fillColor: [200, 200, 200] }
    });

    // Grupo BALON ENVASADO
    if (codigosEnvasado.length > 0) {
      headerRow1Envasado.push({
        content: 'BALON ENVASADO',
        colSpan: codigosEnvasado.length,
        styles: { halign: 'center', fillColor: [255, 193, 7], textColor: [0, 0, 0] }
      });
    }

    // Columnas individuales: PLATO y datos monetarios
    const columnasIndividuales = [
      'PLATO', 'EFECTIVO', 'YAPE', 'FISE', 'TARJETA',
      'DEPÓSITO', 'GASTO', 'CRÉDITO', 'TOTAL', 'SALDO FALT.'
    ];
    columnasIndividuales.forEach(col => {
      headerRow1Envasado.push({
        content: col,
        rowSpan: 2,
        styles: { halign: 'center', valign: 'middle', fillColor: [200, 200, 200] }
      });
    });

    // Segunda fila: nombres de artículos envasados
    codigosEnvasado.forEach((codigo: string) => {
      const label = obtenerNombre(codigo, 18);
      headerRow2Envasado.push({
        content: label,
        styles: { halign: 'center', fillColor: [255, 224, 130], overflow: 'linebreak', fontSize: 6 }
      });
    });

    // Construir filas de datos
    const rowsEnvasado: any[] = [];
    const totalesEnvasado: any = {
      balones: {},
      plato: 0, efectivo: 0, yape: 0, fise: 0, tarjeta: 0,
      deposito: 0, gasto: 0, credito: 0, total: 0, saldo_faltante: 0
    };

    codigosEnvasado.forEach(c => totalesEnvasado.balones[c] = 0);

    ventasData.forEach((venta: any) => {
      const row: any[] = [];
      row.push(venta.vendedor || '');

      // Balones envasados
      codigosEnvasado.forEach((codigo: string) => {
        const valor = Number(venta[codigo] || 0);
        row.push(valor);
        totalesEnvasado.balones[codigo] += valor;
      });

      // Plato y datos monetarios
      row.push(venta.plato || 0);
      row.push(Number(venta.efectivo || 0).toFixed(1));
      row.push(Number(venta.yape || 0).toFixed(1));
      row.push(Number(venta.fise || 0).toFixed(1));
      row.push(Number(venta.tarjeta || 0).toFixed(1));
      row.push(Number(venta.deposito || 0).toFixed(1));
      row.push(Number(venta.gasto || 0).toFixed(1));
      row.push(Number(venta.credito || 0).toFixed(1));
      row.push(Number(venta.total || 0).toFixed(1));
      row.push(Number(venta.saldo_faltante || 0).toFixed(1));

      totalesEnvasado.plato += venta.plato || 0;
      totalesEnvasado.efectivo += Number(venta.efectivo || 0);
      totalesEnvasado.yape += Number(venta.yape || 0);
      totalesEnvasado.fise += Number(venta.fise || 0);
      totalesEnvasado.tarjeta += Number(venta.tarjeta || 0);
      totalesEnvasado.deposito += Number(venta.deposito || 0);
      totalesEnvasado.gasto += Number(venta.gasto || 0);
      totalesEnvasado.credito += Number(venta.credito || 0);
      totalesEnvasado.total += Number(venta.total || 0);
      totalesEnvasado.saldo_faltante += Number(venta.saldo_faltante || 0);

      rowsEnvasado.push(row);
    });

    // Fila de totales
    const rowTotalEnvasado: any[] = ['TOTAL'];
    codigosEnvasado.forEach(c => rowTotalEnvasado.push(totalesEnvasado.balones[c]));
    rowTotalEnvasado.push(totalesEnvasado.plato);
    rowTotalEnvasado.push(totalesEnvasado.efectivo.toFixed(1));
    rowTotalEnvasado.push(totalesEnvasado.yape.toFixed(1));
    rowTotalEnvasado.push(totalesEnvasado.fise.toFixed(1));
    rowTotalEnvasado.push(totalesEnvasado.tarjeta.toFixed(1));
    rowTotalEnvasado.push(totalesEnvasado.deposito.toFixed(1));
    rowTotalEnvasado.push(totalesEnvasado.gasto.toFixed(1));
    rowTotalEnvasado.push(totalesEnvasado.credito.toFixed(1));
    rowTotalEnvasado.push(totalesEnvasado.total.toFixed(1));
    rowTotalEnvasado.push(totalesEnvasado.saldo_faltante.toFixed(1));
    rowsEnvasado.push(rowTotalEnvasado);

    // Estilos de columnas
    const columnStylesEnvasado: any = {
      0: { halign: 'left', cellWidth: 32 }
    };
    let colIndex = 1;
    // Artículos envasados
    for (let i = 0; i < codigosEnvasado.length; i++) {
      columnStylesEnvasado[colIndex++] = { halign: 'center', cellWidth: 15 };
    }
    // Plato y monetarios
    columnStylesEnvasado[colIndex++] = { halign: 'center', cellWidth: 12 }; // PLATO
    for (let i = 0; i < 9; i++) { // 9 columnas monetarias
      columnStylesEnvasado[colIndex++] = { halign: 'right', cellWidth: 13 };
    }

    (doc as any).autoTable({
      head: [headerRow1Envasado, headerRow2Envasado],
      body: rowsEnvasado,
      startY: 32,
      margin: { horizontal: 5 },
      theme: 'grid',
      columnStyles: columnStylesEnvasado,
      styles: {
        fontSize: 6,
        cellPadding: 1,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        fontSize: 6
      },
      didParseCell: (data: any) => {
        if (data.row.index === rowsEnvasado.length - 1 && data.section === 'body') {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fillColor = [255, 243, 205];
        }
      }
    });

    // ==============================================
    // PÁGINA 2: BALONES VACÍOS + PLATOS + DATOS MONETARIOS
    // ==============================================
    if (codigosVacio.length > 0) {
      doc.addPage('landscape');
      addHeader('Detalle de Balones Vacíos');

      // Construir encabezados con dos filas
      const headerRow1Vacio: any[] = [];
      const headerRow2Vacio: any[] = [];

      // Columna VENDEDOR
      headerRow1Vacio.push({
        content: 'VENDEDOR',
        rowSpan: 2,
        styles: { halign: 'center', valign: 'middle', fillColor: [200, 200, 200] }
      });

      // Grupo BALON VACIO
      headerRow1Vacio.push({
        content: 'BALON VACIO',
        colSpan: codigosVacio.length,
        styles: { halign: 'center', fillColor: [156, 39, 176], textColor: [255, 255, 255] }
      });

      // Columnas individuales: PLATO y datos monetarios
      columnasIndividuales.forEach(col => {
        headerRow1Vacio.push({
          content: col,
          rowSpan: 2,
          styles: { halign: 'center', valign: 'middle', fillColor: [200, 200, 200] }
        });
      });

      // Segunda fila: nombres de artículos vacíos
      codigosVacio.forEach((codigo: string) => {
        const label = obtenerNombre(codigo, 18);
        headerRow2Vacio.push({
          content: label,
          styles: { halign: 'center', fillColor: [225, 190, 231], overflow: 'linebreak', fontSize: 6 }
        });
      });

      // Construir filas de datos
      const rowsVacio: any[] = [];
      const totalesVacio: any = {
        balones: {},
        plato: 0, efectivo: 0, yape: 0, fise: 0, tarjeta: 0,
        deposito: 0, gasto: 0, credito: 0, total: 0, saldo_faltante: 0
      };

      codigosVacio.forEach(c => totalesVacio.balones[c] = 0);

      ventasData.forEach((venta: any) => {
        const row: any[] = [];
        row.push(venta.vendedor || '');

        // Balones vacíos
        codigosVacio.forEach((codigo: string) => {
          const valor = Number(venta[codigo] || 0);
          row.push(valor);
          totalesVacio.balones[codigo] += valor;
        });

        // Plato y datos monetarios (MISMOS valores que en página 1)
        row.push(venta.plato || 0);
        row.push(Number(venta.efectivo || 0).toFixed(1));
        row.push(Number(venta.yape || 0).toFixed(1));
        row.push(Number(venta.fise || 0).toFixed(1));
        row.push(Number(venta.tarjeta || 0).toFixed(1));
        row.push(Number(venta.deposito || 0).toFixed(1));
        row.push(Number(venta.gasto || 0).toFixed(1));
        row.push(Number(venta.credito || 0).toFixed(1));
        row.push(Number(venta.total || 0).toFixed(1));
        row.push(Number(venta.saldo_faltante || 0).toFixed(1));

        totalesVacio.plato += venta.plato || 0;
        totalesVacio.efectivo += Number(venta.efectivo || 0);
        totalesVacio.yape += Number(venta.yape || 0);
        totalesVacio.fise += Number(venta.fise || 0);
        totalesVacio.tarjeta += Number(venta.tarjeta || 0);
        totalesVacio.deposito += Number(venta.deposito || 0);
        totalesVacio.gasto += Number(venta.gasto || 0);
        totalesVacio.credito += Number(venta.credito || 0);
        totalesVacio.total += Number(venta.total || 0);
        totalesVacio.saldo_faltante += Number(venta.saldo_faltante || 0);

        rowsVacio.push(row);
      });

      // Fila de totales
      const rowTotalVacio: any[] = ['TOTAL'];
      codigosVacio.forEach(c => rowTotalVacio.push(totalesVacio.balones[c]));
      rowTotalVacio.push(totalesVacio.plato);
      rowTotalVacio.push(totalesVacio.efectivo.toFixed(1));
      rowTotalVacio.push(totalesVacio.yape.toFixed(1));
      rowTotalVacio.push(totalesVacio.fise.toFixed(1));
      rowTotalVacio.push(totalesVacio.tarjeta.toFixed(1));
      rowTotalVacio.push(totalesVacio.deposito.toFixed(1));
      rowTotalVacio.push(totalesVacio.gasto.toFixed(1));
      rowTotalVacio.push(totalesVacio.credito.toFixed(1));
      rowTotalVacio.push(totalesVacio.total.toFixed(1));
      rowTotalVacio.push(totalesVacio.saldo_faltante.toFixed(1));
      rowsVacio.push(rowTotalVacio);

      // Estilos de columnas
      const columnStylesVacio: any = {
        0: { halign: 'left', cellWidth: 32 }
      };
      colIndex = 1;
      // Artículos vacíos
      for (let i = 0; i < codigosVacio.length; i++) {
        columnStylesVacio[colIndex++] = { halign: 'center', cellWidth: 15 };
      }
      // Plato y monetarios
      columnStylesVacio[colIndex++] = { halign: 'center', cellWidth: 12 }; // PLATO
      for (let i = 0; i < 9; i++) {
        columnStylesVacio[colIndex++] = { halign: 'right', cellWidth: 13 };
      }

      (doc as any).autoTable({
        head: [headerRow1Vacio, headerRow2Vacio],
        body: rowsVacio,
        startY: 32,
        margin: { horizontal: 5 },
        theme: 'grid',
        columnStyles: columnStylesVacio,
        styles: {
          fontSize: 6,
          cellPadding: 1,
          overflow: 'linebreak'
        },
        headStyles: {
          fillColor: [200, 200, 200],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          fontSize: 6
        },
        didParseCell: (data: any) => {
          if (data.row.index === rowsVacio.length - 1 && data.section === 'body') {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fillColor = [225, 190, 231];
          }
        }
      });
    }

    return doc.output('blob');
  }



  /**
   * Muestra el PDF en el modal
   */
  private mostrarPDFEnModal(blob: Blob) {
    this.limpiarPDF();
    this.pdfBlob = blob;
    this.pdfObjectUrl = URL.createObjectURL(blob);
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfObjectUrl);
  }

  /**
   * Abre el modal programáticamente
   */
  private abrirModal() {
    if (this.btnshow) {
      this.btnshow.nativeElement.click();
    }
  }

  /**
   * Descarga el PDF
   */
  descargarPDF() {
    if (!this.pdfBlob || !this.pdfObjectUrl) return;

    const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
    const nombreArchivo = `reporte_ventas_diarias_detallado_${fecha}.pdf`;

    const link = document.createElement('a');
    link.href = this.pdfObjectUrl;
    link.download = nombreArchivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  /**
   * Imprime el PDF desde el iframe
   */
  imprimirPDF() {
    if (!this.pdfIframe) return;

    const iframe = this.pdfIframe.nativeElement;
    if (iframe.contentWindow) {
      iframe.contentWindow.print();
    }
  }

  /**
   * Cierra el modal y limpia recursos
   */
  cerrarModal() {
    this.limpiarPDF();
  }

  /**
   * Limpia los recursos del PDF
   */
  private limpiarPDF() {
    if (this.pdfObjectUrl) {
      URL.revokeObjectURL(this.pdfObjectUrl);
    }
    this.pdfBlob = null;
    this.pdfUrl = null;
    this.pdfObjectUrl = '';
  }
  ngOnDestroy() {
    this.limpiarPDF();
  }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }

  // printerVentasDiariosDetallado(
  //   ventasData: any[],
  //   clases: any,
  //   articulos: string[],
  //   nombresArticulos?: { [codigo: string]: string }
  // ) {
  //   const doc = new jsPDF('landscape');
  //   const titulo = { text: 'REPORTE DIARIO DETALLADO', x: 120, y: 20 };

  //   const addHeader = () => {
  //     doc.setFontSize(12); // tamaño de título ligeramente menor por la reducción general
  //     doc.text(titulo.text, titulo.x, titulo.y);
  //     const textWidth = doc.getTextWidth(titulo.text);
  //     const lineY = titulo.y + 1;
  //     doc.setLineWidth(0.5);
  //     doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
  //     doc.setFontSize(9);
  //     doc.text(`Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`, 10, 28);
  //     doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 220, 28);
  //     doc.setFontSize(10);
  //   };

  //   // Helper: obtener solo el NOMBRE (sin mostrar código). Si no existe, devuelve cadena vacía.
  //   const nombres = nombresArticulos || {};
  //   const obtenerNombre = (codigo: string, maxLen = 40): string => {
  //     const key = String(codigo).trim();
  //     const raw = nombres[key];
  //     if (raw && String(raw).trim()) {
  //       const name = String(raw).trim();
  //       return name.length > maxLen ? name.slice(0, maxLen - 1).trim() + '…' : name;
  //     }
  //     return '';
  //   };

  //   // Preparar datos
  //   const tableRows: any[] = [];
  //   const totales: any = {
  //     vendedor: 'TOTAL',
  //     balones_envasado: {},
  //     balones_vacios: {},
  //     plato: 0,
  //     efectivo: 0,
  //     fise: 0,
  //     yape: 0,
  //     deposito: 0,
  //     gasto: 0,
  //     credito: 0,
  //     total: 0
  //   };

  //   // Identificar códigos por tipo (clases: { 'BALON-ENVASADO': ['10','11'], ... })
  //   let codigosEnvasado: string[] = [];
  //   let codigosVacio: string[] = [];

  //   Object.keys(clases || {}).forEach((clase: string) => {
  //     if (clase.toUpperCase().includes('ENVASADO')) {
  //       codigosEnvasado = clases[clase] || [];
  //     } else if (clase.toUpperCase().includes('VACIO')) {
  //       codigosVacio = clases[clase] || [];
  //     }
  //   });

  //   codigosEnvasado.forEach((codigo: string) => { totales.balones_envasado[codigo] = 0; });
  //   codigosVacio.forEach((codigo: string) => { totales.balones_vacios[codigo] = 0; });

  //   // Construir filas (datos)
  //   ventasData.forEach((venta: any) => {
  //     const row: any[] = [];
  //     row.push(venta.vendedor || '');

  //     codigosEnvasado.forEach((codigo: string) => {
  //       const valor = Number(venta[String(codigo)] || 0);
  //       row.push(valor);
  //       totales.balones_envasado[codigo] += valor;
  //     });

  //     codigosVacio.forEach((codigo: string) => {
  //       const valor = Number(venta[String(codigo)] || 0);
  //       row.push(valor);
  //       totales.balones_vacios[codigo] += valor;
  //     });

  //     row.push(venta.plato || 0);
  //     row.push(venta.efectivo ? Number(venta.efectivo).toFixed(1) : '0.0');
  //     row.push(venta.fise || 0);
  //     row.push(venta.yape ? Number(venta.yape).toFixed(1) : '0.0');
  //     row.push(venta.deposito || 0);
  //     row.push(venta.gasto ? Number(venta.gasto).toFixed(1) : '0.0');
  //     row.push(venta.credito || 0);
  //     row.push(venta.total ? Number(venta.total).toFixed(1) : '0.0');

  //     totales.plato += (venta.plato || 0);
  //     totales.efectivo += (venta.efectivo || 0);
  //     totales.fise += (venta.fise || 0);
  //     totales.yape += (venta.yape || 0);
  //     totales.deposito += (venta.deposito || 0);
  //     totales.gasto += (venta.gasto || 0);
  //     totales.credito += (venta.credito || 0);
  //     totales.total += (venta.total || 0);

  //     tableRows.push(row);
  //   });

  //   // Fila totales
  //   const rowTotal: any[] = [];
  //   rowTotal.push('TOTAL');
  //   codigosEnvasado.forEach((codigo: string) => rowTotal.push(totales.balones_envasado[codigo]));
  //   codigosVacio.forEach((codigo: string) => rowTotal.push(totales.balones_vacios[codigo]));
  //   rowTotal.push(totales.plato);
  //   rowTotal.push(totales.efectivo.toFixed(1));
  //   rowTotal.push(totales.fise);
  //   rowTotal.push(totales.yape.toFixed(1));
  //   rowTotal.push(totales.deposito);
  //   rowTotal.push(totales.gasto.toFixed(1));
  //   rowTotal.push(totales.credito);
  //   rowTotal.push(totales.total.toFixed(1));
  //   tableRows.push(rowTotal);

  //   // Construir encabezados: fila 1 (grupos) y fila 2 (nombres)
  //   const headerRow1: any[] = [];
  //   const headerRow2: any[] = [];

  //   headerRow1.push({
  //     content: 'VENDEDOR',
  //     rowSpan: 2,
  //     styles: { halign: 'center', valign: 'middle', fillColor: [200, 200, 200] }
  //   });

  //   headerRow1.push({
  //     content: 'BALON ENVASADO',
  //     colSpan: Math.max(codigosEnvasado.length, 1),
  //     styles: { halign: 'center', fillColor: [255, 255, 0], textColor: [0, 0, 0] }
  //   });

  //   headerRow1.push({
  //     content: 'BALON VACIO',
  //     colSpan: Math.max(codigosVacio.length, 1),
  //     styles: { halign: 'center', fillColor: [255, 255, 0], textColor: [0, 0, 0] }
  //   });

  //   const otrasColumnas = ['plato', 'efectivo', 'fise', 'yape', 'deposito', 'gasto', 'credito', 'total'];
  //   otrasColumnas.forEach(col => {
  //     headerRow1.push({
  //       content: col.toUpperCase(),
  //       rowSpan: 2,
  //       styles: { halign: 'center', valign: 'middle', fillColor: [200, 200, 200] }
  //     });
  //   });

  //   // Segunda fila: SOLO NOMBRE (vacío si no existe)
  //   // -> aplicamos styles con cellWidth pequeño y overflow: 'linebreak' para forzar salto de línea
  //   codigosEnvasado.forEach((codigo: string) => {
  //     const label = obtenerNombre(codigo, 80); // no recortamos aquí, el wrap lo gestiona autoTable
  //     headerRow2.push({
  //       content: label,
  //       styles: { halign: 'center', fillColor: [220, 220, 220], cellWidth: 18, overflow: 'linebreak' }
  //     });
  //   });
  //   codigosVacio.forEach((codigo: string) => {
  //     const label = obtenerNombre(codigo, 80);
  //     headerRow2.push({
  //       content: label,
  //       styles: { halign: 'center', fillColor: [220, 220, 220], cellWidth: 18, overflow: 'linebreak' }
  //     });
  //   });

  //   // Column styles (anchos reducidos para columnas de artículo)
  //   const columnStyles: any = {
  //     0: { halign: 'left', cellWidth: 36 } // vendedor algo más estrecho que antes
  //   };
  //   let colIndex = 1;
  //   // Envasados: ancho pequeño para provocar wrap
  //   for (let i = 0; i < codigosEnvasado.length; i++) {
  //     columnStyles[colIndex++] = { halign: 'center', cellWidth: 18 };
  //   }
  //   // Vacíos: mismo ancho
  //   for (let i = 0; i < codigosVacio.length; i++) {
  //     columnStyles[colIndex++] = { halign: 'center', cellWidth: 18 };
  //   }
  //   // Resto columnas (monetarias) compactas
  //   for (let i = 0; i < otrasColumnas.length; i++) {
  //     columnStyles[colIndex++] = { halign: 'right', cellWidth: 14 };
  //   }

  //   // Generar tabla con autoTable: reducimos fontSize y cellPadding aquí
  //   (doc as any).autoTable({
  //     head: [headerRow1, headerRow2],
  //     body: tableRows,
  //     startY: 32,
  //     margin: { horizontal: 5 },
  //     theme: 'grid',
  //     columnStyles,
  //     styles: {
  //       fontSize: 6,       // reducción general del tamaño de fuente
  //       cellPadding: 0.9,  // padding reducido
  //       overflow: 'linebreak'
  //     },
  //     headStyles: {
  //       fillColor: [200, 200, 200],
  //       textColor: [0, 0, 0],
  //       fontStyle: 'bold',
  //       fontSize: 6
  //     },
  //     didParseCell: (data: any) => {
  //       // aplicar estilo a fila totales
  //       if (data.row.index === tableRows.length - 1 && data.section === 'body') {
  //         // data.cell.styles.fillColor = [255, 0, 0];
  //         // data.cell.styles.textColor = [255, 255, 255];
  //         data.cell.styles.fontStyle = 'bold';
  //       }
  //     },
  //     didDrawPage: (data: any) => {
  //       addHeader();
  //       const pageNumber = data.pageNumber;
  //       doc.text(`Página ${pageNumber}`, 260, 15);
  //     }
  //   });

  //   // Imprimir
  //   doc.autoPrint({ variant: 'non-conform' });
  //   const blob = doc.output('blob');
  //   const url = URL.createObjectURL(blob);
  //   const iframe = document.createElement('iframe');
  //   iframe.style.display = 'none';
  //   iframe.src = url;
  //   document.body.appendChild(iframe);
  //   iframe.onload = () => { if (iframe.contentWindow) iframe.contentWindow.print(); };
  // }







}
